export function IconEmail(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 22 15" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M.5 3.275l10.598 6.308L21.5 3.29 21.5 14a.5.5 0 01-.41.492L21 14.5H1a.5.5 0 01-.5-.5V3.275zM21 .5a.5.5 0 01.5.5v1.121L11.093 8.417.499 2.112.5 1A.5.5 0 01.91.508L1 .5z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  );
}
